import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap';
import trimName from '../../utils/trimName';

export default class Filters extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dropdownOpen: false,
    };
  }

  toggle = () => {
    this.setState(prevState => ({
      dropdownOpen: !prevState.dropdownOpen,
    }));
  };

  render() {
    const { dropdownOpen } = this.state;
    const { filters, filter, onFilter, filterSeperatorIndex } = this.props;
    return (
      <ButtonDropdown isOpen={dropdownOpen} toggle={this.toggle}>
        <DropdownToggle className="filter-button" caret>
          {trimName(filter.name)}
        </DropdownToggle>
        <DropdownMenu className="filter-dropdown-menu">
          {filters.map((filter, index) => (
            <React.Fragment>
              <DropdownItem key={filter.name} onClick={() => onFilter(filter)}>
                {filter.name}
              </DropdownItem>
              {filterSeperatorIndex === index && <DropdownItem divider />}
            </React.Fragment>
          ))}
        </DropdownMenu>
      </ButtonDropdown>
    );
  }
}

Filters.defaultProps = {
  filters: [],
  filter: {
    name: '',
  },
};

Filters.propTypes = {
  filters: PropTypes.array,
  filter: PropTypes.object,
  onFilter: PropTypes.func,
};



// WEBPACK FOOTER //
// ./src/components/charts/Filters.jsx